<template>
    <CodiceFeanorView tool-module="jwt" />
</template>

<script setup>
import CodiceFeanorView from "../CodiceFeanorView.vue";
</script>
